/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class UsageSetRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return this.store.findRecord('schools/usage-set', params.set_id);
  }
}
